import React from "react";
import { Link } from "react-router-dom";
import PouchCheckbox from "components/PouchCheckbox";
import get from "lodash/get";
import { useMeet } from "util/useMeet";
import { useStatus } from "util/useStatus";

const Options = () => {
  const meet = useMeet();
  const { isOnline } = useStatus();

  return (
    <>
      <div className="config-item">
        <div className="entry-row">
          <div className="input-wrapper">
            <PouchCheckbox
              meetId={meet._id}
              documentId={meet._id}
              name="showOnHomePage"
              value={get(meet, "showOnHomePage")}
              label={
                <span>
                  Show Link On Homepage
                  {!isOnline && (
                    <span style={{ whiteSpace: "normal" }}>
                      {" "}
                      (Won't show until meet is online)
                    </span>
                  )}
                </span>
              }
            />
          </div>
        </div>
        <p>Only check this for real meets. Do not check this for test meets.</p>
      </div>
      <div className="config-item">
        <div className="entry-row">
          <div className="input-wrapper">
            <PouchCheckbox
              meetId={meet._id}
              documentId={meet._id}
              name="lifterRackHeightsEnabled"
              value={get(meet, "lifterRackHeightsEnabled")}
              label="Allow lifters to enter rack heights"
            />
          </div>
        </div>
        <div>
          <Link
            to={`/meets/${meet._id}/rackHeights`}
          >{`${window.location.protocol}//${window.location.hostname}/meets/${meet._id}/rackHeights`}</Link>
        </div>
      </div>
      <div className="config-item">
        <div className="entry-row">
          <div className="input-wrapper">
            <PouchCheckbox
              meetId={meet._id}
              documentId={meet._id}
              name="virtualMeet"
              value={get(meet, "virtualMeet")}
              label="This is a Virtual Meet"
            />
          </div>
        </div>
        <p>Allows lifters to submit video attempts with online form.</p>
      </div>
      <div className="config-item">
        <div className="entry-row">
          <div className="input-wrapper">
            <PouchCheckbox
              meetId={meet._id}
              documentId={meet._id}
              name="runningTotal"
              value={get(meet, "runningTotal")}
              label="Use running total"
            />
          </div>
        </div>
        <p>
          If enabled lifters will have a total registered as soon as they have
          their first successful attempt. For example after the first successful
          squat attempt a lifter's total will be their best squat. If not
          enabled lifters will not register a total until they have completed a
          successful attempt in each lift the division is configured for. For
          example for a full powerlifting division the lifter will not have a
          total until they complete a successful deadlift.
        </p>
      </div>

      <div className="config-item">
        <div className="entry-row">
          <div className="input-wrapper">
            <PouchCheckbox
              meetId={meet._id}
              documentId={meet._id}
              name="enableDisplayV2"
              value={get(meet, "enableDisplayV2")}
              label="Enable Version 2 of Display Page"
            />
          </div>
        </div>
        <p>This is an in development feature and things could change.</p>
        <p>
          For this event switch to the newer more advanced version of the
          display page. This includes new widgets and more options to customize.
          This makes the display page another option for capturing content for a
          livestream. Since the new page configuration url format is not
          compatible with the old version, this is a per meet setting to enable
          transitioning everyone to the new page.
        </p>
        <p>
          Click the gear icon at the top of the display version 2 page to
          configure the page layout.
        </p>

        <ul>
          <li>
            To avoid accidentally moving widgets you must now turn on an edit
            mode. Edit mode shows test data for all widgets.
          </li>
          <li>
            You can set the default configuration right from the display page.
            No more copy and pasting the url to the setup page.
          </li>
          <li>
            Lifter details are now all their own widget so you can resize and
            move each line on its own.
          </li>
          <li>Loading Chart now notifies you when the bar weight changes.</li>
          <li>The livestream overlay bar is available as a widget.</li>
          <li>The livestream overlay next lifters is available as a widget.</li>
          <li>
            New Scrolling marquee widget, contains a lot of lifter info in a
            small amount of vertical space. Great for saving space listing all
            divsions or records.
          </li>
          <li>New Standings widget.</li>
          <li>New Image widget. Can be used for logos or background images.</li>
          <li>New Scoreboard widget.</li>
          <li>New Text widget. Type in any text you want.</li>
          <li>
            You can now select the maximum number of lifter divisions to show on
            the display page.
          </li>
          <li>
            You can now select the maximum number of records to show on the
            display page.
          </li>
          <li>
            Create preset screen configurations that you can easily switch to.
          </li>
          <li>
            Create a remote screen. Load the url on another device or live
            streaming software. Control configuration of that remote screen from
            any other device.
          </li>
          <li>Store a custom theme with the display page configuration.</li>
        </ul>
      </div>
    </>
  );
};

export default Options;
